"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const components_1 = require("@/components");
const constants_1 = require("@/constants");
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const SearchInput = (_a) => {
    var { name, className } = _a, rest = __rest(_a, ["name", "className"]);
    return (core_1.jsx("div", { css: styles_1.default.searchInput(), className: className },
        core_1.jsx(components_1.Input, Object.assign({}, rest, { type: "search", name: name, className: carabiners_1.joinStr(styles_scss_1.default.searchInput, className), accessoryPosition: "left", accessory: {
                default: constants_1.Images.search,
                active: constants_1.Images.searchActive,
                error: constants_1.Images.search,
            } }))));
};
SearchInput.defaultProps = {
    id: undefined,
    value: undefined,
    onChange: undefined,
    placeholder: undefined,
    ariaLabel: '',
    type: 'text',
    onBlur: undefined,
    className: null,
    accessory: null,
    label: '',
};
exports.default = SearchInput;
